export default __webpack_public_path__ + "static/media/1249.731bf543.png";